import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-full  mx-auto max-w-[1190px] h-full">
      <div className="flex min-h-full h-full relative">
        <div className="h-full sticky top-0">
          <div className="lg:min-w-[314px] sm:min-w-[150px] border lg:p-[32px] sm:p-6 h-full bg-white flex flex-col overflow-y-auto ">
            <p className="font-bold text-[24px] ">Privacy Policy</p>

            <a
              href="/privacy-policy#"
              className="font-semibold text-[14px]  mt-10"
            >
              Getting Started
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Overview
            </a>

            <a
              href="/privacy-policy#"
              className="font-semibold text-[14px]  mt-10"
            >
              Privacy
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Substance Privacy Policy
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Privacy FAQ
            </a>

            <a
              href="/privacy-policy#"
              className="font-semibold text-[14px]  mt-10"
            >
              Data Requests
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Data Request Overview
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Data Request Policy
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Transparency Report
            </a>

            <a
              href="/privacy-policy#"
              className="font-semibold text-[14px]  mt-10"
            >
              Compliance
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Cookie Policy
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Substance’s GDPR Commitment
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              California Consumer Privacy Act (CCPA) FAQ
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              FERPA Compliance
            </a>

            <a
              href="/privacy-policy#"
              className="font-semibold text-[14px]  mt-10"
            >
              Security
            </a>
            <a
              href="/privacy-policy#"
              className="text-info font-semibold text-[14px]  mt-3"
            >
              Overview
            </a>
          </div>
        </div>

        <div className="lg:p-20 sm:p-4 lg:w-[876px] sm:w-auto">
          <div className="">
            <p className="font-semibold text-[18px]  text-xl mb-8">
              Effective: October 5, 2020
            </p>

            <p className="text-[16]">
              This Privacy Policy describes how Substance collects, uses and
              discloses information, and what choices you have with respect to
              the information. <br /> <br />
              When we refer to “Substance”, we mean the Substance entity that
              acts as the controller or processor of your information, as
              explained in more detail in the “Identifying the Data Controller
              and Processor” section below.
            </p>
            <p className="font-semibold text-[28px]  text-3xl mb-8 mt-12">
              Table of Contents:
            </p>

            <div className="text-purple-600 font-semibold text-[14px]  flex flex-col">
              <a href="/privacy-policy#" className="text-[16px]">
                • Applicability of this Privacy Policy{" "}
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Information We Collect and Receive
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • How We Use Information
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Data Retention
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • How We Share and Disclose Information
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Security
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Age Limitations
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Changes to this Privacy Policy
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • International Data Transfers
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Data Protection Officer{" "}
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Identifying the Data Controller and Processor
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Your Rights
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • California Privacy Rights
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Data Protection Authority{" "}
              </a>
              <a href="/privacy-policy#" className="text-[16px]">
                • Contacting Slack
              </a>
            </div>

            <p className="font-semibold text-[28px]  text-3xl mb-8 mt-12">
              Applicability Of This Privacy Policy
            </p>

            <p className="text-[16]">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.{" "}
              <br />
              <br />
              Sed ut perspiciatis unde omnis iste natus error sit voluptatem
              accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
              quae ab illo inventore veritatis et quasi architecto beatae vitae
              dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
              aspernatur aut odit aut fugit, sed quia consequuntur magni dolores
              eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam
              est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci
              velit, sed quia non numquam eius modi tempora incidunt ut labore
              et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima
              veniam, quis nostrum exercitationem ullam corporis suscipit
              laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem
              vel eum iure reprehenderit qui in ea voluptate velit esse quam
              nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo
              voluptas nulla pariatur?
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

// Developed By
// Md.Shefat Zeon
// 2023-05-23
